import { useEffect, useRef, useState } from "react";
import botImage from "../../assets/images/chatbot_icon.png";
import notificationSound from "../../assets/audio/chat-notification.mp3";
const MAX_REMINDERS = 3;

const messages = [
  {
    title: "👋 Hi There!",
    text: "How can I help you today?"
  },
  {
    title: "🎓 Need Help?",
    text: "Looking for the right course? Ask me!"
  },
  {
    title: "💬 We're Here!",
    text: "Our AI Assistant is available 24/7."
  }
];
const ChatbotLauncher = ({ onClick }) => {
  const [showTooltip, setShowTooltip] = useState(false);
    const [messageIndex, setMessageIndex] = useState(0);
  const audioRef = useRef(null);

  useEffect(() => {
    // Show only once per browser session
    if (sessionStorage.getItem("chatTooltipShown")) return;

    const timer = setTimeout(() => {
      setShowTooltip(true);

      // Try to play sound
      audioRef.current?.play().catch(() => {
        // Browser may block autoplay until user interaction
      });

      sessionStorage.setItem("chatTooltipShown", "true");

      // Hide after 6 seconds
      setTimeout(() => {
        setShowTooltip(false);
      }, 6000);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  const handleClick = () => {
    setShowTooltip(false);
    onClick();
  };

  return (
    <>
      <div className="chatbot-wrapper">
          {showTooltip && (
          <div className="chat-tooltip">
            <div className="tooltip-title">
              {messages[messageIndex].title}
            </div>

            <div className="tooltip-text">
              {messages[messageIndex].text}
            </div>
          </div>
        )}

        <button
          className="chatbot-launcher"
          onClick={handleClick}
          type="button"
          title="Chatbot"
        >
          <img
            src={botImage}
            alt="Chatbot"
            className="launcher-icon"
          />
        </button>
      </div>

      <audio ref={audioRef} preload="auto">
        <source src={notificationSound} type="audio/mpeg" />
      </audio>
    </>
  );
};

export default ChatbotLauncher;